import { reactKeycloakWebContext } from '@react-keycloak/web/lib/context';
import React, { useEffect, useReducer, useState } from 'react';
const ContextProvider = reactKeycloakWebContext.Provider;
export default process.env.REACT_APP_KEYCLOAK_MOCK_USER
    ? function withMockProvider() {
        const mockUser = JSON.parse(process.env.REACT_APP_KEYCLOAK_MOCK_USER);
        function useAuthClientMock({ user: { realm_access, resource_access, ...idTokenParsed }, onTokens, }) {
            const [, forceUpdate] = useReducer((x) => x + 1, 0);
            const [authenticated, setAuthenticated] = useState(false);
            return {
                idTokenParsed: authenticated ? idTokenParsed : undefined,
                authenticated,
                login() {
                    setAuthenticated(true);
                    onTokens({
                        token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
                        refreshToken: '<refreshToken>',
                    });
                    forceUpdate();
                },
                logout(options) {
                    setAuthenticated(false);
                    forceUpdate();
                    if (options === null || options === void 0 ? void 0 : options.redirectUri) {
                        globalThis.location.href = options.redirectUri;
                    }
                },
                hasRealmRole(role) {
                    var _a;
                    return authenticated && ((_a = realm_access === null || realm_access === void 0 ? void 0 : realm_access.roles) === null || _a === void 0 ? void 0 : _a.includes(role));
                },
                hasResourceRole(role, resource) {
                    var _a, _b;
                    return (authenticated &&
                        ((_b = (_a = resource_access === null || resource_access === void 0 ? void 0 : resource_access[resource]) === null || _a === void 0 ? void 0 : _a.roles) === null || _b === void 0 ? void 0 : _b.includes(role)));
                },
            };
        }
        return function MockProvider({ LoadingComponent, onTokens = () => { }, children, initOptions: { token, refreshToken } = {}, }) {
            const [initialized, setInitialized] = useState(false);
            const authClient = useAuthClientMock({
                user: mockUser,
                onTokens,
            });
            useEffect(() => {
                setTimeout(() => {
                    onTokens({ token, refreshToken });
                    if (token && refreshToken) {
                        authClient.login();
                    }
                    setInitialized(true);
                }, 200);
                // eslint-disable-next-line react-hooks/exhaustive-deps
            }, []);
            return initialized || !LoadingComponent ? (React.createElement(ContextProvider, { value: { authClient, initialized } }, children)) : (LoadingComponent);
        };
    }
    : (Provider) => Provider;
//# sourceMappingURL=withMockProvider.js.map